import { withRouter } from 'react-router-dom';
import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector, reset, blur, untouch, change } from 'redux-form';
import PropTypes from 'prop-types';
import {
  setCustomerInfo,
  removeSaveError,
} from '../../redux/services/customer-info/customer-info-service';
import { logout } from '../../redux/services/login-service/loginService';
import {
  setAgentApplicationUpdates,
  deleteAgentApplication,
} from '../../redux/services/agent-application-info/agent-application-info-service';
import { bindActionCreators } from 'redux';
import CustomerInfoForm from '../../components/customer-info/customer-info';
import SummaryPage from '../../components/summary-page/summary-page';
import { getInsuranceCompanyByDetail } from '../../redux/services/insurance-comp-info/insurance-comp-info-service';
import ProgressIndicator from '../../components/common/progress-indicator/progress-indicator';
import { numberFormat } from '../../constants/constants';
import _ from 'lodash';
import Stepper from '../../components/stepper/stepper';
const insurCompReason =
  'Insurance Company does not meet minimum rating requirement';
class CustomerInfoContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      infoSubmitted: false,
      data: {},
      insuranceInfo: undefined,
      insurNotfound: false,
      depositAmtDiff: false,
      showPreview: false,
      customerInfo: {},
      modalOpen: false,
      deleteId: null,
      prevNotSelected: false,
      activeStep: 1,
    };
  }

  componentDidMount = () => {
    if (
      _.isEmpty(this.props.customerInfo) &&
      this.props.location.state === undefined
    ) {
      this.props.history.push('/home');
    }
  };

  trim = str => {
    if (str !== undefined) {
      let result = str.toString().replace(/,/g, '');
      return Number(result);
    }
  };

  trimStr = str => {
    if (str !== undefined) {
      return str.trim();
    }
  };

  toCurrency = value => {
    return value !== undefined ? numberFormat(value) : value;
  };

  toDecimal = value => {
    return value !== undefined ? this.trim(value).toFixed(2) : value;
  };

  getActivityComments = activity => {
    return _.sortBy(activity, function (o) {
      return o.activityTimestamp;
    }).reverse();
  };

  handleInsuranceValidation = customerInfo => {
    if (
      !_.isEmpty(this.props.insurAddr) &&
      Array.isArray(this.props.insurAddr) &&
      customerInfo.insuranceCompanyName !== undefined &&
      customerInfo.insuranceCompanyName ===
        this.props.insurAddr.insuranceCompanyName &&
      customerInfo.insuranceCompanyStrAddr ===
        this.props.insurAddr.insuranceCompanyStrAddr
    ) {
      this.setState({
        prevNotSelected: true,
      });
    }
  };

  handleInsurCompNotFound = e => {
    e.preventDefault();
    if (!this.state.insurNotfound) {
      this.setState({ insurNotfound: true });
    } else {
      this.setState({ insurNotfound: false });
    }
  };

  getMsg = activity => {
    return !_.isEmpty(activity[0].statusAddComments) &&
      activity[0].statusAddComments !== undefined &&
      activity[0].statusAddComments !== null
      ? activity[0].statusAddComments
      : '';
  };

  getComments = customerInfo => {
    if (customerInfo.appComments !== undefined) {
      let activity = this.getActivityComments(customerInfo.activity);
      if (
        customerInfo.appComments !== null &&
        !_.isEmpty(customerInfo.appComments)
      ) {
        let thirdMsg = this.getMsg(activity);
        return (
          <ul key="1">
            <li key="1">{customerInfo.appComments.toString()}</li>
            {!_.isEmpty(thirdMsg) && <li key="2">{thirdMsg}</li>}
          </ul>
        );
      } else if (
        !customerInfo.depositAmtDiff &&
        customerInfo.appComments !== null &&
        !_.isEmpty(customerInfo.appComments)
      ) {
        let thirdMsg = this.getMsg(activity);
        return (
          <ul key="1">
            <li key="1">{customerInfo.appComments.toString()}</li>
            {!_.isEmpty(thirdMsg) && activity[0].statusAddComments !== null && (
              <li key="2">{thirdMsg}</li>
            )}
          </ul>
        );
      } else if (
        customerInfo.appComments !== null &&
        !_.isEmpty(customerInfo.appComments) &&
        activity[0].statusAddComments === ''
      ) {
        return <p key="1">{customerInfo.appComments.toString()}</p>;
      }
    } else {
      return null;
    }
  };

  getInsuCompFromValues = values => {
    let insurComp;
    if (values.insurCompAddr1 !== undefined) {
      insurComp = this.props.insuranceInfo.filter(
        item => item.insuranceCompanyStrAddr === values.insurCompAddr1,
      );
    } else if (values.insurAddrCheck) {
      insurComp = this.props.insuranceInfo.filter(
        item => item.insuranceCompanyName === values.insurComp,
      );
    }
    return insurComp;
  };

  setNextPageValues = (customerInfo, values, insurComp) => {
    if (insurComp === undefined) {
      insurComp = this.getInsuranceAddress(values);
    }
    console.log('setNextPageValues', customerInfo, values, insurComp);
    if (
      customerInfo.depositQuoteAmt !== this.trim(values.depositAmt) &&
      !values.diffAmt
    ) {
      this.setState({ depositAmtDiff: true });
    } else if (
      customerInfo.depositQuoteAmt !== this.trim(values.depositAmt) &&
      values.diffAmt
    ) {
      this.setState({
        depositAmtDiff: false,
        data: values,
        insuranceInfo: insurComp[0],
        infoSubmitted: true,
        activeStep: 2,
      });
    } else if (
      customerInfo.depositQuoteAmt === this.trim(values.depositAmt) &&
      !values.diffAmt
    ) {
      this.setStateForSummary(false, values, insurComp[0], true, 2);
    } else if (
      customerInfo.depositQuoteAmt !== undefined &&
      customerInfo.depositQuoteAmt === this.trim(values.depositAmt)
    ) {
      this.setState({
        depositAmtDiff: false,
        data: values,
        insuranceInfo: insurComp[0],
        infoSubmitted: true,
      });
    }
  };

  setStateForSummary = (
    depositAmtDiff,
    data,
    insuranceInfo,
    infoSubmitted,
    activeStep,
  ) => {
    this.setState({
      depositAmtDiff: depositAmtDiff,
      data: data,
      insuranceInfo: insuranceInfo,
      infoSubmitted: infoSubmitted,
      activeStep: activeStep,
    });
  };

  setSummaryPageValues = customerInfo => {
    if (
      customerInfo.appStatus === 'PENDING_FOR_NOTARY' &&
      !this.state.infoSubmitted
    ) {
      this.setState({ infoSubmitted: true, activeStep: 2 });
      this.setState({ data: {} });
    }
  };

  handleSubmit = values => {
    console.log('values-info container', values, this.props.insurComp);
    this.getInsuranceAddress(this.props.insurComp);
    let insurComp = this.getInsuCompFromValues(values);
    if (this.props.customerInfo.depositQuoteAmt !== undefined) {
      this.setNextPageValues(this.props.customerInfo, values, insurComp);
    } else if (
      this.props.location.state !== undefined &&
      this.props.location.state.data !== undefined
    ) {
      this.setNextPageValues(this.props.location.state.data, values, insurComp);
    }

    console.log('customerinfo-state', this.state);
  };

  handleConfirmation = e => {
    e.preventDefault();
    this.setState({
      insuranceInfo: this.getInsuranceInfo(
        this.state.data,
        this.state.insuranceInfo,
      ),
    });
    if (this.state.data.correctionsMade === undefined) {
      this.props.setCustomerInfo(
        this.getPayload(
          this.state.data,
          this.props.customerInfo,
          this.props.currentUser,
          this.getInsuranceInfo(this.state.data, this.state.insuranceInfo),
        ),
        this.props.token,
      );
    } else {
      this.props.setAgentApplicationUpdates(
        this.getUpdatedPayload(
          this.state.data,
          this.props.location.state.data,
          this.props.currentUser,
          this.getInsuranceInfo(this.state.data, this.state.insuranceInfo),
        ),
        this.props.token,
      );
    }
  };

  getInsuranceAddress = name => {
    let result = null;
    if (
      this.props.insuranceInfo !== undefined &&
      this.props.insuranceInfo !== null
    ) {
      result = this.props.insuranceInfo.filter(
        item => item.insuranceCompanyName === name,
      );
    }

    if (
      (this.props.insurAddrCheck && this.state.insurNotfound) ||
      (result !== null && result !== undefined && result.length > 1)
    ) {
      this.props.blur('customerInfoForm', 'insurAddrCheck', false);
    }

    console.log('this.getInsuranceAddress', result);
    return result;
  };

  resetStepper = () => {
    this.setState({ infoSubmitted: false, activeStep: 1 });
  };

  handleBack = event => {
    // console.log('customerInfoForm-1', this.state);
    this.props.blur('customerInfoForm', 'insurComp', this.state.data.insurComp);
    event.preventDefault();
    console.log('confirmation-back', event.target.value);
    if (this.state.infoSubmitted && this.props.location.state === undefined) {
      this.setState({ infoSubmitted: false, activeStep: 1 });
    } else if (
      this.state.infoSubmitted &&
      this.props.location.state !== undefined &&
      this.props.location.state.data !== undefined
    ) {
      this.setState({
        infoSubmitted: false,
        activeStep: 1,
        showSuccessPage: false,
      });
    }
    this.props.removeSaveError();
  };

  handleCustomerInfoBack = e => {
    e.preventDefault();
    console.log('customerInfoForm-2', this.state);
    reset('customerInfoForm');
    this.props.history.push('/home');
  };

  handleCustomerInfoCancel = e => {
    e.preventDefault();
    console.log('customerInfoForm-3', this.state);
    reset('customerInfoForm');
    this.props.history.push('/home', { page: 'query' });
  };

  getInsuranceInfo = (data, insuranceInfo) => {
    let info;
    if (insuranceInfo === undefined) {
      info = {
        insuranceCompanyName: data.insurcompanyName,
        insuranceCompanyStrAddr: data.insurStr,
        insuranceCompanyStrAddr2: data.insurStr2,
        insuranceCompanyCity: data.insurCity,
        insuranceCompanyState: data.insurState,
        insuranceCompanyZipCode: data.insurZipcode,
      };
    } else {
      info = insuranceInfo;
    }
    return info;
  };

  getPayload = (data, customerInfo, currentUser, insuranceInfo) => {
    let reason = this.getReasons(data.reasons);
    let payload = {
      billAccount: customerInfo.billAccount,
      taxId: customerInfo.taxId,
      district: customerInfo.district,
      profile: {
        companyName: customerInfo.companyName,
        street: customerInfo.street,
        streetline2: customerInfo.streetline2,
        city: customerInfo.city,
        state: customerInfo.state,
        zipCode: customerInfo.zipCode,
        email: customerInfo.email,
      },
      depositDueDate: customerInfo.depositDueDate,
      depositQuote: customerInfo.depositQuoteAmt,
      depositAmt: this.trim(data.depositAmt),
      depositAmtDiff:
        customerInfo.depositQuoteAmt === this.trim(data.depositAmt)
          ? false
          : true,
      bondNumber: data.bondNo,
      status: 'READY_FOR_REVIEW',
      submittedStatus: 'SUBMITTED',
      isApplicationUpdated:
        data.correctionsMade !== undefined ? data.correctionsMade : false,
      blankAcc: customerInfo.blanketAcc,
      appComments: reason,
      insurDetails: {
        insCompanyName: insuranceInfo.insuranceCompanyName.toUpperCase(),
        insCompAddrStr: insuranceInfo.insuranceCompanyStrAddr.toUpperCase(),
        insCompAddrStr2: insuranceInfo.insuranceCompanyStrAddr2,
        insCompAddrCity: insuranceInfo.insuranceCompanyCity.toUpperCase(),
        insCompAddrState: insuranceInfo.insuranceCompanyState,
        insCompAddrZipCode: insuranceInfo.insuranceCompanyZipCode,
      },
      insuranceCompanyAdded: this.state.insurNotfound,
      agent: currentUser,
      activity: [
        {
          activityStatus: 'READY_FOR_REVIEW',
          updatedBy: currentUser.emailAddress,
          statusComments:
            `Deposit Quote Amount as of  ` +
            numberFormat(customerInfo.depositQuoteAmt),
          statusAddComments:
            reason !== undefined && reason.length !== 0
              ? reason.toString()
              : '',
        },
      ],
    };
    console.log('customer-info-save-payload', payload);
    return payload;
  };
  getReasons = comments => {
    let reason = [];
    if (
      Array.isArray(comments) &&
      comments !== undefined &&
      comments !== null
    ) {
      return comments;
    } else if (comments !== null && comments !== undefined) {
      reason.push(comments);
      return reason;
    }
  };
  getUpdatedPayload = (data, customerInfo, currentUser, insuranceInfo) => {
    console.log('customerInfo.insuranceCompanyName', customerInfo);
    let comments =
      customerInfo.appComments !== null &&
      customerInfo.appComments !== undefined
        ? customerInfo.appComments.toString()
        : '';
    let reason = this.getReasons(data.reasons);

    return {
      id: customerInfo.id,
      billAccount: customerInfo.billAccount,
      taxId: customerInfo.taxId,
      district: customerInfo.district,
      companyName: customerInfo.companyName,
      depositAmt: this.trim(data.depositAmt),
      depositAmtDiff:
        customerInfo.depositQuoteAmt === this.trim(data.depositAmt)
          ? false
          : true,
      bondNumber:
        customerInfo.bondNumber === data.bondNo
          ? customerInfo.bondNumber
          : data.bondNo,
      status: 'READY_FOR_REVIEW',
      submittedStatus: 'PENDING_CORRECTIONS',
      applicationUpdated: data.correctionsMade,
      appComments: reason,
      insurDetails: {
        insCompanyName: insuranceInfo.insuranceCompanyName.toUpperCase(),
        insCompAddrStr: insuranceInfo.insuranceCompanyStrAddr.toUpperCase(),
        insCompAddrStr2: insuranceInfo.insuranceCompanyStrAddr2,
        insCompAddrCity: insuranceInfo.insuranceCompanyCity.toUpperCase(),
        insCompAddrState: insuranceInfo.insuranceCompanyState.toUpperCase(),
        insCompAddrZipCode: insuranceInfo.insuranceCompanyZipCode,
      },
      insuranceCompanyAdded: this.state.insurNotfound,

      agent: {
        emailAddress: currentUser.emailAddress,
      },
      activity: {
        activityStatus: 'READY_FOR_REVIEW',
        updatedBy: currentUser.emailAddress,
        statusComments:
          comments !== ''
            ? 'Admin Comments :' + comments
            : 'Application Submitted with Changes  ',
        statusAddComments:
          reason !== undefined && reason.length !== 0
            ? reason.toString()
            : 'Previous Insurance Company-' + customerInfo.insuranceCompanyName,
      },
    };
  };

  handlePreview = value => {
    return value === true ? true : false;
  };

  handleAgentHomeCancel = e => {
    e.preventDefault();
    console.log('cancel value', e.currentTarget.value);
    this.setState({ modalOpen: true });
    this.setState({ deleteId: this.trim(e.currentTarget.value) });
  };

  handleModalClose = e => {
    e.preventDefault();
    this.setState({ modalOpen: false });
  };

  handleAppDelete = e => {
    e.preventDefault();
    console.log('cancel value-2', this.state.deleteId);
    let payload = this.props.location.state.data;
    console.log('delete Payload', payload);
    this.props.deleteAgentApplication(payload, this.props.token);
    this.setState({ modalOpen: false });
  };

  setIntialValues = (depositAmt1, depositAmtDiff, bondNumber) => {
    if (
      this.props.location.state !== undefined &&
      this.props.location.state.data !== undefined &&
      this.props.location.state.data.insuranceCompanyAdded
    ) {
      if (!this.state.insurNotfound) {
        this.setState({
          insurNotfound: true,
        });
      }
      let customerInfo = this.props.location.state.data;
      return {
        depositAmt: depositAmt1,
        diffAmt: depositAmtDiff,
        bondNo: bondNumber,
        insurcompanyName: customerInfo.insuranceCompanyName,
        insurStr: customerInfo.insuranceCompanyStrAddr,
        insurStr2: customerInfo.insuranceCompanyStrAddr2,
        insurCity: customerInfo.insuranceCompanyCity,
        insurState: customerInfo.insuranceCompanyState,
        insurZipcode: customerInfo.insuranceCompanyZipCode,
      };
    } else if (
      this.props.location.state !== undefined &&
      this.props.location.state.data !== undefined &&
      !this.props.location.state.data.insuranceCompanyAdded &&
      this.props.location.state.data.appComments !== null &&
      this.props.location.state.data.appComments !== undefined &&
      this.props.location.state.data.appComments[0] !== insurCompReason &&
      this.props.location.state.data.appComments[0] !==
        'Insurance Company name or address is incorrect.'
    ) {
      let customerInfo = this.props.location.state.data;
      return {
        depositAmt: depositAmt1,
        diffAmt: depositAmtDiff,
        bondNo: bondNumber,
        insurComp: customerInfo.insuranceCompanyName,
      };
    } else {
      return {
        depositAmt: depositAmt1,
        diffAmt: depositAmtDiff,
        bondNo: bondNumber,
      };
    }
  };

  getInsuranceCompanies = () => {
    if (
      this.props.insuranceInfo !== undefined &&
      this.props.insuranceInfo !== null
    ) {
      return _.uniq(
        _.map(this.props.insuranceInfo, 'insuranceCompanyName'),
      ).sort();
    } else {
      return [];
    }
  };

  render() {
    console.log('customer-info props:', this.props);
    let customerInfo;
    let bondNumber = '';
    let depositAmt1;
    let depositAmtDiff = false;
    if (
      this.props.location.state !== undefined &&
      this.props.location.state.data !== undefined
    ) {
      customerInfo = this.props.location.state.data;
      this.handleInsuranceValidation(customerInfo);
      bondNumber = customerInfo.bondNumber;
      depositAmt1 = this.toDecimal(customerInfo.depositBondAmt);
      depositAmtDiff = customerInfo.depositAmtDiff;
      this.setSummaryPageValues(customerInfo);
      if (
        this.props.insurAddrCheck &&
        this.props.insurComp === customerInfo.insuranceCompanyName &&
        this.getComments(customerInfo) === insurCompReason
      ) {
        this.props.blur('customerInfoForm', 'insurAddrCheck', false);
        console.log('this.props.blur', this.props.insurAddrCheck);
      } else if (
        this.props.insurcompanyName === customerInfo.insuranceCompanyName &&
        this.getComments(customerInfo) === insurCompReason
      ) {
        this.props.untouch('customerInfoForm', 'insurcompanyName', '');
        console.log('this.props.blur', this.props.insurAddrCheck);
        this.props.change('customerInfoForm', 'correctionsMade', false);
      }
    } else {
      customerInfo = this.props.customerInfo;
    }
    return this.props.isLoading ? (
      <div>
        <ProgressIndicator />
      </div>
    ) : (
      <div>
        <Stepper activeStep={this.state.activeStep} />
        {!this.state.showSuccessPage && !this.state.infoSubmitted && (
          <CustomerInfoForm
            customerInfo={customerInfo}
            errors={this.props.error}
            insuranceInfo={this.getInsuranceCompanies()}
            onSubmit={this.handleSubmit.bind(this)}
            insurCompNotfound={this.handleInsurCompNotFound.bind(this)}
            insurNotfound={this.state.insurNotfound}
            depositAmtDiff={this.state.depositAmtDiff}
            handleCustomerInfoBack={this.handleCustomerInfoBack.bind(this)}
            handleCustomerInfoCancel={this.handleCustomerInfoCancel.bind(this)}
            depositAmt={this.props.depositAmt}
            depositQuote={this.toCurrency(customerInfo.depositQuoteAmt)}
            insurAddr={this.getInsuranceAddress(this.props.insurComp)}
            selectedInsu={this.props.insurComp}
            comments={this.getComments(customerInfo)}
            modalOpen={this.state.modalOpen}
            handleAgentHomeCancel={this.handleAgentHomeCancel.bind(this)}
            handleModalClose={this.handleModalClose.bind(this)}
            handleAppDelete={this.handleAppDelete.bind(this)}
            previousInsur={this.state.prevNotSelected}
            insurcompanyName={this.props.insurcompanyName}
            initialValues={this.setIntialValues(
              depositAmt1,
              depositAmtDiff,
              bondNumber,
            )}
          />
        )}

        {!this.state.showSuccessPage && this.state.infoSubmitted && (
          <React.Fragment>
            <SummaryPage
              submit={this.handleConfirmation.bind(this)}
              data={this.state.data}
              customerInfo={customerInfo} // your data array of objects
              insuranceInfo={this.state.insuranceInfo}
              back={this.handleBack.bind(this)}
              errors={this.props.error}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}
const selector = formValueSelector('customerInfoForm');
const mapStateToProps = state => ({
  customerInfo: state.customerInfoReducer.customerInfo,
  insuranceInfo: state.insuranceReducer.insuranceInfo,
  currentUser: state.appReducer.currentUser,
  token: state.appReducer.token,
  error: state.customerInfoReducer.error,
  depositAmt: selector(state, 'depositAmt'),
  insurComp: selector(state, 'insurComp'),
  insurAddrCheck: selector(state, 'insurAddrCheck'),
  insurcompanyName: selector(state, 'insurcompanyName'),

  isLoading:
    state.customerInfoReducer.isLoading === undefined
      ? state.agentApplicationInfoReducer.isLoading
      : state.customerInfoReducer.isLoading,
});

const mapDispatchToProps = dispatch => ({
  setCustomerInfo: bindActionCreators(setCustomerInfo, dispatch),
  setAgentApplicationUpdates: bindActionCreators(
    setAgentApplicationUpdates,
    dispatch,
  ),
  getInsuranceCompanyInfo: bindActionCreators(
    getInsuranceCompanyByDetail,
    dispatch,
  ),
  deleteAgentApplication: bindActionCreators(deleteAgentApplication, dispatch),
  blur: bindActionCreators(blur, dispatch),
  change: bindActionCreators(change, dispatch),
  untouch: bindActionCreators(untouch, dispatch),
  logOut: bindActionCreators(logout, dispatch),
  removeSaveError: bindActionCreators(removeSaveError, dispatch),
});

CustomerInfoContainer.propTypes = {
  error: PropTypes.string,
  token: PropTypes.string,
  depositAmt: PropTypes.string,
  register: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  customerInfo: PropTypes.shape({
    companyName: PropTypes.string,
    billAccount: PropTypes.number,
    taxId: PropTypes.number,
    street: PropTypes.string,
    streetLine2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipcode: PropTypes.number,
    depositDueDate: PropTypes.string,
    depositQuoteAmt: PropTypes.number,
  }),
  insuranceInfo: PropTypes.arrayOf(
    PropTypes.shape({
      insuranceCompanyName: PropTypes.string,
      address: PropTypes.string,
      filter: PropTypes.func,
    }),
  ),
  setCustomerInfo: PropTypes.func,
  getInsuranceCompanyInfo: PropTypes.func,
  setAgentApplicationUpdates: PropTypes.func,
  deleteAgentApplication: PropTypes.func,
  currentUser: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    companyName: PropTypes.string,
    street: PropTypes.string,
    streetline2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipcode: PropTypes.number,
    emailAddress: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
  insurAddrCheck: PropTypes.bool,
  insurAddr: PropTypes.object,
  blur: PropTypes.func,
  untouch: PropTypes.func,
  change: PropTypes.func,
  removeSaveError: PropTypes.func,
  insurComp: PropTypes.array,
  location: PropTypes.shape({
    state: PropTypes.object,
  }),
  insurcompanyName: PropTypes.string,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CustomerInfoContainer),
);
